import { Vue, Component } from 'vue-property-decorator';
import MerchantRedirectNotification from '../components/MerchantRedirectNotification.vue';

@Component({
  components: {
    MerchantRedirectNotification,
  },
})
export default class MerchantAccountMixin extends Vue {
  public merchantNotification = {
    show: false,
    redirectUrl: '',
    message: '',
    banner: '',
    beforeAuthorization: () => Promise.resolve(),
  }

  public showMerchantRedirect(
    payload: {
      redirectUrl: string;
      message: string;
      banner: string,
      beforeAuthorization?: () => Promise<void>;
    },
  ) {
    const {
      redirectUrl, message, banner, beforeAuthorization,
    } = payload;

    this.merchantNotification = {
      redirectUrl,
      message,
      banner,
      beforeAuthorization: beforeAuthorization || (() => Promise.resolve()),
      show: true,
    };
  }
}
